import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

/**
 * Reusable component for rendering a text-only value prop header
 *
 * @param {string|object}   [className] - additional class(es) added to header element
 * @param {string}          [title] - the title for the header
 * @param {string}          [subtitle] - text to display as a value prop
 */
export const TextOnlyHeader = ({className = "", title, subtitle}) => {
    return (
        <div className={classnames("text-center", className)}>
            <h4 className="spark-text-24px-bold mb-3">{title}</h4>
            <h5 className="spark-text-16px-secondary mb-3">{subtitle}</h5>
        </div>
    );
};

TextOnlyHeader.propTypes = {
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
};
